import { setDefaultSEOData } from 'store/seo/actions';

import type { universalRouterProps } from 'core/universalRouter/types';

export default ({ store: { dispatch } }: universalRouterProps) => {
  return Promise.all([dispatch(setDefaultSEOData())]);
};
